export default __webpack_public_path__ + "static/texture-watermelon-4ceb6d91620bab68126b9a8dd26f4c37.png";